import isEmpty from 'lodash/isEmpty';
/**
 * Accepts a string with templates with variable substitution and a key-value object
 * with the replacements. This is similar to how python's str.format works and allows us
 * to define strings and dynamically replace the variables
 * @param {string} string - template string with variables to replace
 * @param {Object} replacements - object where the keys are the variables in the template string to replace
 * @returns {string} string with the templates removed and replaced with the values in replacements
 */
export const templateStringFormat = (string = '', replacements) => {
  const templateRegex = /\{(\w+)\}/g;
  return string.replace(templateRegex, (match, p1) => replacements[p1]);
};

/**
 * Accept an object with key values and converts it to a query string
 * @param {Object} query - key value pairs
 * @returns {string} query string
 */
export function queryParamsToString(query) {
  if (isEmpty(query)) return '';

  const urlsSearchParams = new URLSearchParams(query);
  return `?${urlsSearchParams.toString()}`;
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js